import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./aboutUsLayout.css";
import AboutInfoContainer from "../../AboutInfoContainer/AboutInfoContainer";
import aboutimage from "../../Assets/aboutusImage.png";
import vissionimage from "../../Assets/target.png";
import AboutVissionAndMission from "../../AboutInfoContainer/AboutVissionAndMission";
import CoreValues from "../../AboutInfoContainer/CoreValues";
import IndustriesWeServe from "../../AboutInfoContainer/IndustriesWeServe";
import WhyChooseUs from "../../AboutInfoContainer/WhyChooseUs";
import OurVision from "../../AboutInfoContainer/OurVision";
import Footer from "../Footer/Footer";

const AboutUsLayout = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const sectionRefs = useRef([]);
  const isManualScroll = useRef(false);

  const sections = [
    "introduction",
    "vision-mission",
    "core-values-section",
    "industries-we-serve",
    "material-component",
    "why-choose-us",
  ];

  const menuItems = [
    "Introduction",
    "Mission",
    "Values",
    "Industries",
    "Materials",
    "Why Us?",
  ];

  const handleResize = () => setIsMobile(window.innerWidth <= 768);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Scroll into section
  const scrollToSection = (index) => {
    const target = sectionRefs.current[index];
    if (target) {
      isManualScroll.current = true;
      target.scrollIntoView({ behavior: "smooth" });
      setActiveIndex(index);
      setTimeout(() => {
        isManualScroll.current = false;
      }, 1000);
    }
  };

  // Detect current visible section
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (isManualScroll.current) return;

        let mostVisible = { ratio: 0, index: null };

        entries.forEach((entry) => {
          const index = sectionRefs.current.findIndex(
            (el) => el === entry.target
          );
          if (entry.isIntersecting && entry.intersectionRatio > mostVisible.ratio) {
            mostVisible = { ratio: entry.intersectionRatio, index };
          }
        });

        if (mostVisible.index !== null && mostVisible.index !== activeIndex) {
          setActiveIndex(mostVisible.index);
        }
      },
      {
        threshold: [0.3, 0.5, 0.7],
      }
    );

    sectionRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [activeIndex]);


  // Avoid vertical body scroll
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  // const [initialCoreIndex, setInitialCoreIndex] = useState(false);
  // const [initialWhyIndex, setInitialWhyIndex] = useState(false);

  // useEffect(() => {
  //   if (activeIndex === 2) setInitialCoreIndex(true);
  //   if (activeIndex === 5) setInitialWhyIndex(true);
  // }, [activeIndex]);

  const contentComponents = [
    <div style={{ margin: 'auto 0px' }}>
      <AboutInfoContainer
        title={
          <i id="introduction">
            We don’t just shape Metal, <br /> We shape the Industry.
          </i>
        }
        text="When it comes to manufacturing superior industrial equipment, your search ends here. 
Welcome to Alok Fabrications, where quality isn't just a promise, it's our foundation. We are an ISO 9001:2015 certified company, ensuring that every step of our process, from high-quality manufacturing to expert fabrication, is executed to the highest standards. We obsess over every detail, turning your vision into reality with products that are built to perform and last."
      />
    </div>,
    <div style={{ margin: 'auto 0px' }}>
      <AboutVissionAndMission
        id="vision-mission"
        title="Your Vision, Our Mission"
        textOne={
          <><b>At Alok Fabrications, we believe metal can be a force for good.</b> That’s why we manufacture not only top-tier equipment but also a more sustainable future. <b>Collaboration is our cornerstone</b>, because your success is our success. Every project is an opportunity to showcase our passion and turn your vision into reality.</>
        }
        // image={
        //   <img
        //     src={vissionimage}
        //     alt="Vision and Mission"
        //     className="responsive-image"
        //   />
        // }
      /></div>,
    <CoreValues
    // setInitialIndex={setInitialCoreIndex}
    // initialIndex={initialCoreIndex}
    />,
    <IndustriesWeServe />,
    <OurVision />,
    <WhyChooseUs
    // setInitialIndex={setInitialWhyIndex}
    // initialIndex={initialWhyIndex}
    />,
  ];
  const tabRefs = useRef([]);

  useEffect(() => {
    if (tabRefs.current[activeIndex]) {
      tabRefs.current[activeIndex].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [activeIndex]);
  const getHeightStyle = (index) => {
    if (index === 5) return { height: isMobile ? "110vh" : "75vh" };
    if (index === 2) return { height: isMobile ? "100vh" : "75vh" };
    return {};
  };
  return (
    <div className="main-container">
      <section className="section_about" id="aboutuslayout">
        <Container>
          <div className="content-row">
            {!isMobile && (
              <Col className="sidebar">
                <ul className="menu">
                  {menuItems.map((item, index) => (
                    <li
                      key={index}
                      className={activeIndex === index ? "active" : ""}
                      onClick={() => scrollToSection(index)}
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </Col>
            )}

            <div className="content">
              {contentComponents.map((Component, index) => (
                <div
                  key={index}
                  id={sections[index]}
                  ref={(el) => (sectionRefs.current[index] = el)}
                  className="content-section"
                  style={getHeightStyle(index)}
                >
                  {Component}
                </div>
              ))}
            </div>
          </div>
        </Container>
      </section>

      <div style={{ position: 'fixed', bottom: 0, width: '100%' }}>
        {isMobile && (
          <div className="bottom-tab-bar">
            <div className="tab-inner-container">
              {menuItems.map((item, index) => (
                <button
                  key={index}
                  ref={(el) => (tabRefs.current[index] = el)}
                  className={`tab-button ${activeIndex === index ? "active" : ""}`}
                  onClick={() => scrollToSection(index)}
                >
                  {item}
                </button>
              ))}
            </div>
          </div>
        )}
        <Footer isNoHrTag  />
      </div>
    </div>
  );
};

export default AboutUsLayout;
